<template>
	<div>
		<form-sidebar>
			<v-form method="post" @submit.prevent="submitForm">
				<v-layout wrap>
					<v-flex xs12>
						<v-text-field
							background-color="white"
							box
							class="body-1"
							hide-details
							label="Nombre"
							required 
							v-model="model.name"
							:error="$v.model.name.$invalid"
						>
						</v-text-field>
					</v-flex>
					<v-flex xs12>
						<v-textarea
							background-color="white"
							box
							class="body-1"
							hide-details
							label="Descripción"
						 	required
							no-resize
							v-model="model.description"
							:error="$v.model.name.$invalid"
						>
						</v-textarea>
					</v-flex>
				</v-layout>
				<v-layout row pa-2 align-center>
					<v-text-field
						solo
						class="body-1 mr-2 mt-1"
						hide-details
						label="Icono/Imagen"
						required
						v-model="model.pathIcon"
						:error="$v.model.name.$invalid"
					>
					</v-text-field>
					<upload-image 
						label-ref="up"
						label-for="image"
						input-id="image"
						@send-image="getImage"
					/>
				</v-layout>
				<section class="modal-filter-footer">
					<modal-sidebar-button
						:is-loading="$v.$invalid || loading"
						:on-run-service="loading"
						@accept-button-clicked="submitForm"
						@cancel-button-clicked="closeModal"
					/>
				</section>
			</v-form>
		</form-sidebar>
	</div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import UploadImage from '@/components/shared/upload-image';

const PAGE_MODULE_LIST = 'page-module';

function data() {
	return {
		countries: [],
		loading: false,
		model: {
			codeApp: '',
			name: '',
			position: 1,
			pathIcon: '',
		},
	};
}

async function created() {
	if (this.mode === 'edit') {
		const { data: record } = await this.$http.get(`module/${this.moduleId}`);
		if (record.data) {
			this.model = {
				name: record.data.name,
				position: 1,
				pathIcon: record.data.pathIcon,
				description: record.data.description,
			};
		}
	}
	this.model.codeApp = this.codeApp;
}

function closeModal() {
	this.goTo(PAGE_MODULE_LIST);
}

function mode() {
	return this.moduleId ? 'edit' : 'create';
}

async function submitForm() {
	const method = this.mode === 'create' ? 'post' : 'put';
	const url = this.mode === 'create' ? 'module' : `module/${this.moduleId}`;
	this.loading = true;
	try {
		await this.$http[method](url, this.model);
		this.goTo(PAGE_MODULE_LIST);
	} finally {
		this.loading = false;
	}
}

function getImage({ urlImage }) {
	this.model.pathIcon = urlImage;
}

function validations() {
	const validation = {
		model: {
			name: {
				required,
			},
			codeApp: {
				required,
			},
			pathIcon: {
				required,
			},
			description: {
				required,
			},
		},
	};
	return validation;
}

export default {
	name: 'modules-form',
	created,
	computed: {
		mode,
	},
	components: {
		UploadImage,
	},
	data,
	methods: {
		closeModal,
		getImage,
		submitForm,
	},
	props: {
		moduleId: {
			type: [Number, String],
		},
		codeApp: {
			type: String,
			required: true,
		},
	},
	validations,
};
</script>



// WEBPACK FOOTER //
// src/components/modules/module-form.vue